import { Colors } from '@doordash/design-language';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var LoadingSize;

(function (LoadingSize) {
  LoadingSize[LoadingSize["Small"] = 24] = "Small";
  LoadingSize[LoadingSize["Medium"] = 32] = "Medium";
  LoadingSize[LoadingSize["Large"] = 40] = "Large";
  LoadingSize[LoadingSize["XLarge"] = 64] = "XLarge";
  LoadingSize[LoadingSize["XxLarge"] = 96] = "XxLarge";
  LoadingSize[LoadingSize["XxxLarge"] = 128] = "XxxLarge";
})(LoadingSize || (LoadingSize = {}));

var LoadingColors = _objectSpread({
  Dark: Colors.SystemBlack,
  Light: Colors.SystemWhite,
  Red: Colors.SystemRed60,
  Ocean: Colors.SystemTeal60,
  CurrentColor: 'currentColor'
}, Colors);
var LoadingState;

(function (LoadingState) {
  LoadingState["Loading"] = "LOADING/LOADING";
  LoadingState["Success"] = "LOADING/SUCCESS";
  LoadingState["Error"] = "LOADING/ERROR";
  LoadingState["FoodLoop"] = "LOADING/FOOD_LOOP";
})(LoadingState || (LoadingState = {}));

export { LoadingColors, LoadingSize, LoadingState };
